import { render, staticRenderFns } from "./ConfigHotelEditar.vue?vue&type=template&id=f72d329a&scoped=true&"
import script from "./ConfigHotelEditar.vue?vue&type=script&lang=js&"
export * from "./ConfigHotelEditar.vue?vue&type=script&lang=js&"
import style0 from "./ConfigHotelEditar.vue?vue&type=style&index=0&id=f72d329a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72d329a",
  null
  
)

export default component.exports